module.exports = __webpack_public_path__ + "img/1192.b4550376.gif";